// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lkfr-auth-loading {
  color-scheme: light;
  min-height: 100dvh;
  padding: 24px;
  display: grid;
  place-items: center;
  background: radial-gradient(circle at 50% 38%, rgba(42, 171, 238, 0.14), transparent 34%), linear-gradient(180deg, #f7fafc 0%, #eef4f8 100%);
  color: #17212b;
  box-sizing: border-box;
  font-family: "Manrope", "Segoe UI", Arial, sans-serif;
}

.lkfr-auth-loading__card {
  width: min(260px, 100%);
  display: grid;
  justify-items: center;
  gap: 16px;
}

.lkfr-auth-loading__mark {
  position: relative;
  width: 72px;
  height: 72px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #2aabee, #35c1a8);
  box-shadow: 0 18px 44px rgba(42, 171, 238, 0.26);
  overflow: hidden;
}

.lkfr-auth-loading__mark::before {
  content: "";
  position: absolute;
  inset: -45%;
  background: conic-gradient(from 90deg, transparent, rgba(255, 255, 255, 0.74), transparent 32%);
  animation: lkfr-auth-spin 1.15s linear infinite;
}

.lkfr-auth-loading__mark::after {
  content: "";
  position: absolute;
  inset: 4px;
  border-radius: 21px;
  background: linear-gradient(135deg, #2aabee, #35c1a8);
}

.lkfr-auth-loading__mark span {
  position: relative;
  z-index: 1;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #fff;
  animation: lkfr-auth-dot 0.95s ease-in-out infinite;
}

.lkfr-auth-loading__mark span + span {
  margin-left: 6px;
}

.lkfr-auth-loading__mark span:nth-child(2) {
  animation-delay: 0.12s;
}

.lkfr-auth-loading__mark span:nth-child(3) {
  animation-delay: 0.24s;
}

.lkfr-auth-loading__title {
  color: #17212b;
  font-size: 17px;
  font-weight: 800;
  letter-spacing: 0;
}

.lkfr-auth-loading__lines {
  width: 190px;
  display: grid;
  gap: 8px;
}

.lkfr-auth-loading__lines span {
  height: 10px;
  border-radius: 999px;
  overflow: hidden;
  background: rgba(109, 127, 144, 0.13);
}

.lkfr-auth-loading__lines span::after {
  content: "";
  display: block;
  width: 55%;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.86), transparent);
  animation: lkfr-auth-shimmer 1.25s ease-in-out infinite;
}

.lkfr-auth-loading__lines span:nth-child(2) {
  width: 84%;
  justify-self: center;
}

.lkfr-auth-loading__lines span:nth-child(3) {
  width: 62%;
  justify-self: center;
}

.lkfr-auth-error {
  min-height: 100vh;
  padding: 32px 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f9fa;
  color: #232137;
  box-sizing: border-box;
  font-family: "Manrope", "Segoe UI", Arial, sans-serif;
}

@keyframes lkfr-auth-spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes lkfr-auth-dot {
  0%, 80%, 100% {
    transform: translateY(0);
    opacity: 0.58;
  }
  40% {
    transform: translateY(-7px);
    opacity: 1;
  }
}
@keyframes lkfr-auth-shimmer {
  from {
    transform: translateX(-105%);
  }
  to {
    transform: translateX(210%);
  }
}
@media (prefers-reduced-motion: reduce) {
  .lkfr-auth-loading__mark::before,
  .lkfr-auth-loading__mark span,
  .lkfr-auth-loading__lines span::after {
    animation: none;
  }
}
.lkfr-auth-error__content {
  width: 100%;
  max-width: 430px;
  padding: 30px 24px 28px;
  text-align: center;
  background: #fff;
  border: 1px solid #eef1f5;
  border-radius: 18px;
  box-shadow: 0 16px 42px rgba(36, 41, 57, 0.08);
  box-sizing: border-box;
}

.lkfr-auth-error__mark {
  width: 54px;
  height: 54px;
  margin: 0 auto 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #fff0f2;
  color: #e72f44;
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
}

.lkfr-auth-error__title {
  margin: 0;
  color: #232137;
  font-size: 26px;
  font-weight: 800;
  line-height: 1.18;
  letter-spacing: 0;
}

.lkfr-auth-error__text {
  margin: 14px 0 24px;
  color: #667085;
  font-size: 16px;
  line-height: 1.5;
}

.lkfr-auth-error__button {
  width: 100%;
  min-height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 13px 18px;
  border-radius: 14px;
  border: 0;
  background: #e72f44;
  color: #fff;
  font-family: inherit;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.2;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(231, 47, 68, 0.22);
  transition: transform 0.16s ease, background 0.16s ease, box-shadow 0.16s ease;
  box-sizing: border-box;
}

.lkfr-auth-error__button:hover {
  background: #d92539;
  box-shadow: 0 12px 28px rgba(231, 47, 68, 0.28);
  transform: translateY(-1px);
}

.lkfr-auth-error__button:active {
  transform: translateY(0);
}

.lkfr-auth-error__button:focus-visible {
  outline: 3px solid rgba(231, 47, 68, 0.22);
  outline-offset: 3px;
}

@media (max-width: 480px) {
  .lkfr-auth-error {
    padding: 24px 14px;
    align-items: flex-start;
    padding-top: 92px;
  }
  .lkfr-auth-error__content {
    padding: 26px 18px 22px;
    border-radius: 16px;
  }
  .lkfr-auth-error__title {
    font-size: 23px;
  }
  .lkfr-auth-error__text {
    font-size: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/ProtectedRoute.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,4IACE;EAEF,cAAA;EACA,sBAAA;EACA,qDAAA;AADF;;AAIA;EACE,uBAAA;EACA,aAAA;EACA,qBAAA;EACA,SAAA;AADF;;AAIA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qDAAA;EACA,gDAAA;EACA,gBAAA;AADF;;AAIA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,+FAAA;EACA,+CAAA;AADF;;AAIA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,qDAAA;AADF;;AAIA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,sBAAA;AADF;;AAIA;EACE,sBAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AADF;;AAIA;EACE,YAAA;EACA,aAAA;EACA,QAAA;AADF;;AAIA;EACE,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,qCAAA;AADF;;AAIA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,uFAAA;EACA,uDAAA;AADF;;AAIA;EACE,UAAA;EACA,oBAAA;AADF;;AAIA;EACE,UAAA;EACA,oBAAA;AADF;;AAIA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;EACA,qDAAA;AADF;;AAIA;EACE;IACE,yBAAA;EADF;AACF;AAIA;EACE;IAGE,wBAAA;IACA,aAAA;EAJF;EAMA;IACE,2BAAA;IACA,UAAA;EAJF;AACF;AAOA;EACE;IACE,4BAAA;EALF;EAOA;IACE,2BAAA;EALF;AACF;AAUA;EACE;;;IAGE,eAAA;EARF;AACF;AAWA;EACE,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,8CAAA;EACA,sBAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AATF;;AAYA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AATF;;AAYA;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AATF;;AAYA;EACE,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,+CAAA;EACA,8EAAA;EACA,sBAAA;AATF;;AAYA;EACE,mBAAA;EACA,+CAAA;EACA,2BAAA;AATF;;AAYA;EACE,wBAAA;AATF;;AAYA;EACE,0CAAA;EACA,mBAAA;AATF;;AAYA;EACE;IACE,kBAAA;IACA,uBAAA;IACA,iBAAA;EATF;EAYA;IACE,uBAAA;IACA,mBAAA;EAVF;EAaA;IACE,eAAA;EAXF;EAcA;IACE,eAAA;EAZF;AACF","sourcesContent":[".lkfr-auth-loading {\n  color-scheme: light;\n  min-height: 100dvh;\n  padding: 24px;\n  display: grid;\n  place-items: center;\n  background:\n    radial-gradient(circle at 50% 38%, rgba(42, 171, 238, 0.14), transparent 34%),\n    linear-gradient(180deg, #f7fafc 0%, #eef4f8 100%);\n  color: #17212b;\n  box-sizing: border-box;\n  font-family: \"Manrope\", \"Segoe UI\", Arial, sans-serif;\n}\n\n.lkfr-auth-loading__card {\n  width: min(260px, 100%);\n  display: grid;\n  justify-items: center;\n  gap: 16px;\n}\n\n.lkfr-auth-loading__mark {\n  position: relative;\n  width: 72px;\n  height: 72px;\n  border-radius: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #2aabee, #35c1a8);\n  box-shadow: 0 18px 44px rgba(42, 171, 238, 0.26);\n  overflow: hidden;\n}\n\n.lkfr-auth-loading__mark::before {\n  content: \"\";\n  position: absolute;\n  inset: -45%;\n  background: conic-gradient(from 90deg, transparent, rgba(255, 255, 255, 0.74), transparent 32%);\n  animation: lkfr-auth-spin 1.15s linear infinite;\n}\n\n.lkfr-auth-loading__mark::after {\n  content: \"\";\n  position: absolute;\n  inset: 4px;\n  border-radius: 21px;\n  background: linear-gradient(135deg, #2aabee, #35c1a8);\n}\n\n.lkfr-auth-loading__mark span {\n  position: relative;\n  z-index: 1;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: #fff;\n  animation: lkfr-auth-dot 0.95s ease-in-out infinite;\n}\n\n.lkfr-auth-loading__mark span + span {\n  margin-left: 6px;\n}\n\n.lkfr-auth-loading__mark span:nth-child(2) {\n  animation-delay: 0.12s;\n}\n\n.lkfr-auth-loading__mark span:nth-child(3) {\n  animation-delay: 0.24s;\n}\n\n.lkfr-auth-loading__title {\n  color: #17212b;\n  font-size: 17px;\n  font-weight: 800;\n  letter-spacing: 0;\n}\n\n.lkfr-auth-loading__lines {\n  width: 190px;\n  display: grid;\n  gap: 8px;\n}\n\n.lkfr-auth-loading__lines span {\n  height: 10px;\n  border-radius: 999px;\n  overflow: hidden;\n  background: rgba(109, 127, 144, 0.13);\n}\n\n.lkfr-auth-loading__lines span::after {\n  content: \"\";\n  display: block;\n  width: 55%;\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.86), transparent);\n  animation: lkfr-auth-shimmer 1.25s ease-in-out infinite;\n}\n\n.lkfr-auth-loading__lines span:nth-child(2) {\n  width: 84%;\n  justify-self: center;\n}\n\n.lkfr-auth-loading__lines span:nth-child(3) {\n  width: 62%;\n  justify-self: center;\n}\n\n.lkfr-auth-error {\n  min-height: 100vh;\n  padding: 32px 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f7f9fa;\n  color: #232137;\n  box-sizing: border-box;\n  font-family: \"Manrope\", \"Segoe UI\", Arial, sans-serif;\n}\n\n@keyframes lkfr-auth-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes lkfr-auth-dot {\n  0%,\n  80%,\n  100% {\n    transform: translateY(0);\n    opacity: 0.58;\n  }\n  40% {\n    transform: translateY(-7px);\n    opacity: 1;\n  }\n}\n\n@keyframes lkfr-auth-shimmer {\n  from {\n    transform: translateX(-105%);\n  }\n  to {\n    transform: translateX(210%);\n  }\n}\n\n\n\n@media (prefers-reduced-motion: reduce) {\n  .lkfr-auth-loading__mark::before,\n  .lkfr-auth-loading__mark span,\n  .lkfr-auth-loading__lines span::after {\n    animation: none;\n  }\n}\n\n.lkfr-auth-error__content {\n  width: 100%;\n  max-width: 430px;\n  padding: 30px 24px 28px;\n  text-align: center;\n  background: #fff;\n  border: 1px solid #eef1f5;\n  border-radius: 18px;\n  box-shadow: 0 16px 42px rgba(36, 41, 57, 0.08);\n  box-sizing: border-box;\n}\n\n.lkfr-auth-error__mark {\n  width: 54px;\n  height: 54px;\n  margin: 0 auto 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: #fff0f2;\n  color: #e72f44;\n  font-size: 28px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.lkfr-auth-error__title {\n  margin: 0;\n  color: #232137;\n  font-size: 26px;\n  font-weight: 800;\n  line-height: 1.18;\n  letter-spacing: 0;\n}\n\n.lkfr-auth-error__text {\n  margin: 14px 0 24px;\n  color: #667085;\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n.lkfr-auth-error__button {\n  width: 100%;\n  min-height: 48px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 13px 18px;\n  border-radius: 14px;\n  border: 0;\n  background: #e72f44;\n  color: #fff;\n  font-family: inherit;\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 1.2;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  box-shadow: 0 10px 24px rgba(231, 47, 68, 0.22);\n  transition: transform 0.16s ease, background 0.16s ease, box-shadow 0.16s ease;\n  box-sizing: border-box;\n}\n\n.lkfr-auth-error__button:hover {\n  background: #d92539;\n  box-shadow: 0 12px 28px rgba(231, 47, 68, 0.28);\n  transform: translateY(-1px);\n}\n\n.lkfr-auth-error__button:active {\n  transform: translateY(0);\n}\n\n.lkfr-auth-error__button:focus-visible {\n  outline: 3px solid rgba(231, 47, 68, 0.22);\n  outline-offset: 3px;\n}\n\n@media (max-width: 480px) {\n  .lkfr-auth-error {\n    padding: 24px 14px;\n    align-items: flex-start;\n    padding-top: 92px;\n  }\n\n  .lkfr-auth-error__content {\n    padding: 26px 18px 22px;\n    border-radius: 16px;\n  }\n\n  .lkfr-auth-error__title {\n    font-size: 23px;\n  }\n\n  .lkfr-auth-error__text {\n    font-size: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
